import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'

//const baseUrl = process.env.BASE_API;//原
const baseUrl = process.env.VUE_APP_BASE_API; //新
const service = axios.create({
    baseURL: baseUrl,
    timeout: 181000, //请求超时3分钟，如果3分钟超过，就提示
})

service.interceptors.request.use(
    config => {
        //config.headers['Content-Type'] = config.method =='post'?'application/x-www-form-urlencoded':'application/json';
        // if(config.method === 'post') { // 判断如果是put请求, 配置Content-Type
        //     config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        // }else {
        //     config.headers['Content-Type'] = 'application/json'
        // }
        config.headers['token'] = store.getters.token;
        // console.log("config")
        // console.log(config)
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        const res = response.data;
        //console.log('interceptor');
        // console.log("teset")
        // console.log(res)
        // if (res.status !== 200) {
        //   Message({
        //     message: '服务器开小差了QAQ',
        //     type: 'error',
        //     duration: 5 * 1000
        //   })
        //   if (res.status === 50008 || res.status === 50012 || res.status === 50014) {
        //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
        //       confirmButtonText: 'Re-Login',
        //       cancelButtonText: 'Cancel',
        //       type: 'warning'
        //     }).then(() => {
        //       store.dispatch('user/resetToken').then(() => {
        //         location.reload()
        //       })
        //     })
        //   } else if (res.status === 50010) {
        //     Message({
        //       message: '修改失败！',
        //       type: 'error',
        //       duration: 5 * 1000
        //     })
        //   } else if (res.status === 50013) {
        //     Message({
        //       message: '头像上传失败！',
        //       type: 'error',
        //       duration: 5 * 1000
        //     })
        //   }
        //   return Promise.reject(new Error(res.message || 'Error'))
        // } else {
        return res
            // }
    },
    error => {
        Message({
                message: '登录信息过期，请重新登录！',
                type: 'error'
            })
            // window.sessionStorage.clear()
            // document.location.reload()
        return Promise.reject(error)
    }
)

export default service